import React, { useState, useEffect, useContext } from "react"
import Table from "../../Components/TableTemplate/Table"
import AdjustmentTable from "./Adjustment/AdjustmentTable"
import { Form, Tab, Tabs, Row, Col } from "react-bootstrap"
import toast from "react-hot-toast"
import {
  getSevenDaysAgo,
  getType,
  selectDropdownStyle,
} from "../../Helpers/Utils/Common"
import Select from "react-select"
//components
import Navbar from "../../Components/Navbar/Navbar"
import AdjustmentModal from "./Adjustment/AdjustmentModal"
import Moment from "moment"
import DatePicker from "react-datepicker"

//css
import "./Inventory.css"
import "../../Components/Navbar/Navbar.css"

//api
import { searchBranch } from "../../Helpers/apiCalls/Manage/Branches"
import {
  searchAdjustments,
  getAllAdjustmentItemType,
} from "../../Helpers/apiCalls/Inventory/AdjustmentApi"

import { getAllItems } from "../../Helpers/apiCalls/itemsApi"

import { numberFormat, toastStyle } from "../../Helpers/Utils/Common"
import { getCategory } from "../../Helpers/apiCalls/categoryApi"
import { useNavigate } from "react-router-dom"
import Footer from "../../Components/Footer/Footer"
import AdjustmentTableWithDynamicPagination from "../../Components/TableTemplate/AdjustmentTableWithDynamicPagination"
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination"
// import { Context } from "../../Helpers/Utils/Context"

export default function Adjustments() {
  let navigate = useNavigate()
  // const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
  //   useContext(Context)
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [branches, setBranches] = useState([])
  const [items, setItems] = useState([])
  const [itemType, setItemType] = useState([])
  const [selectedTab, setSelectedTab] = useState(true)
  const [checkedAdjustments, setCheckedAdjustments] = useState([])
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  const [selectedBranch, setSelectedBranch] = useState([
    {
      label: "All Branches",
      value: "",
    },
  ])
  const [selectedItem, setSelectedItem] = useState([
    {
      label: "All Items",
      value: "",
    },
  ])

  /* approve modal handler */
  const [showAdjustmentModal, setShowAdjustmentModal] = useState(false)
  const handleShowAdjustmentModal = () => {
    checkedAdjustments.length !== 0
      ? setShowAdjustmentModal(true)
      : toast.error("Please select adjustment to approve", {
          style: toastStyle(),
        })
  }
  const handleAdjustmentModal = () => setShowAdjustmentModal(false)

  /* disapprove modal handler */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const handleShowDisapproveModal = () => {
    checkedAdjustments.length !== 0
      ? setShowDisapproveModal(true)
      : toast.error("Please select Adjustment to disapprove", {
          style: toastStyle(),
        })
  }
  const handleDisapproveModal = () => setShowDisapproveModal(false)

  /* ========== FILTER CONFIGS ========== */
  const [adjustmentsManager, setAdjustmentsManager] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    status: "pending",
    branch_id: "",
    item_id: "",
    encoded_on_from: "",
    encoded_on_to: "",
    date_from: getSevenDaysAgo(),
    date_to: new Date(),
    name: "",
    type: "warehouse",
    shop: "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  async function fetchAdjustments() {
    setShowLoader(true)
    setAdjustmentsManager([])
    setTotalItems(0)

    const response = await searchAdjustments(filterConfig)
    if (response.data) {
      var sortedData = response.data.data.sort((a, b) =>
        a.added_on > b.added_on ? 1 : b.added_on > a.added_on ? -1 : 0
      )
      var adjustments = sortedData.reverse().map((adjust) => {
        var info = adjust
        info.encoded_on = Moment(adjust.added_on).format("MMM DD, YYYY")
        info.physical_count = numberFormat(adjust.physical_count)
        info.computer_count = numberFormat(adjust.computer_count)
        info.difference = numberFormat(adjust.difference)
        info.type = ""
        return info
      })

      setAdjustmentsManager(adjustments)
      setTotalItems(response.data.size)
    }

    setShowLoader(false)
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    if (tabKey === "pending") {
      setSelectedTab(true)
    } else {
      setSelectedTab(false)
    }

    setFilterConfig((prev) => {
      return {
        ...prev,
        status: tabKey,
        // date_from: tabKey !== "approved" ? aweekago : "",
        // date_to: tabKey !== "disapproved" ? today : "",
        date_from: getSevenDaysAgo(),
        date_to: new Date(),
        page: 1,
      }
    })
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      }
    })
  }

  function ViewBtn(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleViewBtn(row.id, row.type)}
      >
        View
      </button>
    )
  }

  function handleViewBtn(id, type) {
    navigate("/adjustments/view/" + id, "_blank")
  }

  const [branchOptions, setBranchOptions] = useState([])

  useEffect(() => {
    setBranchOptions(
      branches.map((_branch) => {
        var retval = { label: _branch.name, value: _branch.id }
        return retval
      })
    )
    setBranchOptions((branchesOptions) => {
      var newBranches = [...branchesOptions]
      newBranches.push({ label: "All Branches", value: "" })
      return newBranches.reverse()
    })
  }, [branches])

  function handleBranchChange(e) {
    const toFilter = { target: { name: "branch_id", value: e.value } }
    var branchval = {
      label: e.label,
      value: e.value,
    }
    setSelectedBranch(branchval)
    handleFilterChange(toFilter)
  }

  const [itemOptions, setItemOptions] = useState([])

  useEffect(() => {
    setItemOptions(
      items.map((_item) => {
        var retval = { label: _item.name, value: _item.id }
        return retval
      })
    )
    setItemOptions((itemOptions) => {
      var newBranches = [...itemOptions]
      newBranches.push({ label: "All Items", value: "" })
      return newBranches.reverse()
    })
  }, [items])

  function handleItemChange(e) {
    const toFilter = { target: { name: "item_id", value: e.value } }
    var branchval = {
      label: e.label,
      value: e.value,
    }
    setSelectedItem(branchval)
    handleFilterChange(toFilter)
  }

  function handleOnCheck(row) {
    setCheckedAdjustments(row.selectedRows)
  }

  // API INTEGRATIONS
  async function fetchBranches() {
    const response = await searchBranch({ is_franchise: "3" })
    // ({is_franchise: "3"});

    if (response.data) {
      var data = response.data.data
      var sortedData = data.sort((a, b) =>
        a.name.toUpperCase() > b.name.toUpperCase()
          ? 1
          : b.name.toUpperCase() > a.name.toUpperCase()
          ? -1
          : 0
      )
      setBranches(sortedData.reverse())
    } else {
    }
  }

  async function fetchAllItems() {
    const response = await getAllItems()

    if (response.response) {
      var data = response.response.data
      setItems(data.reverse())
    } else {
    }
  }

  async function fetchAllItemType() {
    const response = await getAllAdjustmentItemType("")

    if (response.data) {
      var data = response.data.data
      setItemType(data)
    } else {
    }
  }

  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.value = category.id
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
      //subcategories
      var subcategories = response.data.subcategories.map((category) => {
        var info = {}
        info.value = category.subname
        info.label = category.subname
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)
    }
  }

  useEffect(() => {
    var subcat = subCategories.filter((data) => {
      return data.category_id === filterConfig?.category_id
    })
    setFilteredSubCategories(subcat)
  }, [filterConfig.category])

  useEffect(() => {
    fetchCategories()
    fetchBranches()
    fetchAllItems()
    fetchAllItemType()
  }, [])

  useEffect(() => {
    fetchAdjustments()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WH INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ADJUSTMENTS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              className="search-bar"
              placeholder="Search..."
              // defaultValue=""
              // onChange={(e) => handleFilterChange(e)}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            ></input>
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                eventKey="braddex"
                onClick={() => navigate("/branch-adjustments/add/warehouse")}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>
        {/* tabs */}
        <Tabs
          activeKey={filterConfig.status}
          defaultActiveKey={filterConfig.status}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="pending" title="pending">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  value={selectedBranch}
                  options={branchOptions}
                  onChange={handleBranchChange}
                />
              </Col>
              {/* <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter px-0 py-0 me-2"
                    classNamePrefix="react-select"
                    placeholder="Select item"
                    // defaultValue={{label: "All Items", value:""}}
                    styles={selectDropdownStyle}
                    value={selectedItem}
                    options={itemOptions}
                    onChange={handleItemChange}
                  />
                </Col> */}
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_category}
                  options={[
                    { label: "All Categories", value: "" },
                    ...categories,
                  ]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        category: e.label,
                        category_id: e.value,
                        selected_category: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="type_id"
                  className="date-filter me-2"
                  value={filterConfig.type_id}
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All Type
                  </option>
                  {itemType.length > 0 ? (
                    itemType.map((data) => {
                      return <option value={data.id}>{data.name}</option>
                    })
                  ) : (
                    <option value="" disabled>
                      (No type found)
                    </option>
                  )}
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={"Select date from"}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={"Select date to"}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  className="date-filter me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-3" />

            {/* table */}
            <AdjustmentTableWithDynamicPagination
              tableHeaders={[
                ".",
                "ENCODED ON",
                "BRANCH",
                "ITEM",
                "UNIT",
                "DIFFERENCE",
                "PHYS COUNT",
                "COM COUNT",
                "TYPE",
                "REMARKS",
                "COUNTED BY",
              ]}
              headerSelector={[
                ".",
                "encoded_on",
                "branch_name",
                "item_name",
                "unit",
                "difference",
                "physical_count",
                "computer_count",
                "type_name",
                "remarks",
                "counted_by_name",
              ]}
              tableData={adjustmentsManager}
              showLoader={showLoader}
              handleOnCheck={(row) => handleOnCheck(row)}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="approved" title="approved">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  value={selectedBranch}
                  options={branchOptions}
                  onChange={handleBranchChange}
                />
              </Col>
              {/* <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select item"
                    // defaultValue={{label: "All Items", value:""}}
                    styles={selectDropdownStyle}
                    value={selectedItem}
                    options={itemOptions}
                    onChange={handleItemChange}
                  />
                </Col> */}
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_category}
                  options={[
                    { label: "All Categories", value: "" },
                    ...categories,
                  ]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        category: e.label,
                        category_id: e.value,
                        selected_category: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="type_id"
                  className="date-filter me-2"
                  value={filterConfig.type_id}
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All Type
                  </option>
                  {itemType.length > 0 ? (
                    itemType.map((data) => {
                      return <option value={data.id}>{data.name}</option>
                    })
                  ) : (
                    <option value="" disabled>
                      (No type found)
                    </option>
                  )}
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={"Select date from"}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={"Select date to"}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  className="date-filter me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-3" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ENCODED ON",
                "BRANCH",
                "ITEM",
                "UNIT",
                "DIFFERENCE",
                "PHYS COUNT",
                "COM COUNT",
                "TYPE",
                "REMARKS",
                "ADM REMARKS",
                "COUNTED BY",
                "APPROVED BY",
              ]}
              headerSelector={[
                "-",
                "encoded_on",
                "branch_name",
                "item_name",
                "unit",
                "difference",
                "physical_count",
                "computer_count",
                "type_name",
                "remarks",
                "admin_remarks",
                "counted_by_name",
                "approved_by_name",
              ]}
              tableData={adjustmentsManager}
              ViewBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="disapproved" title="disapproved">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  value={selectedBranch}
                  options={branchOptions}
                  onChange={handleBranchChange}
                />
              </Col>
              {/* <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select item"
                    // defaultValue={{label: "All Items", value:""}}
                    styles={selectDropdownStyle}
                    value={selectedItem}
                    options={itemOptions}
                    onChange={handleItemChange}
                  />
                </Col> */}
              <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_category}
                  options={[
                    { label: "All Categories", value: "" },
                    ...categories,
                  ]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        category: e.label,
                        category_id: e.value,
                        selected_category: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="type_id"
                  className="date-filter me-2"
                  value={filterConfig.type_id}
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All Type
                  </option>
                  {itemType.length > 0 ? (
                    itemType.map((data) => {
                      return <option value={data.id}>{data.name}</option>
                    })
                  ) : (
                    <option value="" disabled>
                      (No type found)
                    </option>
                  )}
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={"Select date from"}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={"Select date to"}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  className="date-filter me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-3" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ENCODED ON",
                "BRANCH",
                "ITEM",
                "UNIT",
                "DIFFERENCE",
                "PHYS COUNT",
                "COM COUNT",
                "TYPE",
                "REMARKS",
                "ADM REMARKS",
                "COUNTED BY",
                "DAPPD BY",
              ]}
              headerSelector={[
                "-",
                "encoded_on",
                "branch_name",
                "item_name",
                "unit",
                "difference",
                "physical_count",
                "computer_count",
                "type_name",
                "remarks",
                "admin_remarks",
                "counted_by_name",
                "disapproved_by_name",
              ]}
              tableData={adjustmentsManager}
              ViewBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
        {selectedTab && getType() === "admin" ? (
          <>
            <div className="d-flex justify-content-end pt-3 mb-3 mr-3">
              <button
                type="button"
                className="button-primary mr-3 "
                onClick={() => handleShowAdjustmentModal()}
              >
                Approve
              </button>
              <button
                type="button"
                className="button-warning"
                onClick={() => handleShowDisapproveModal()}
              >
                Disapprove
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <AdjustmentModal
        show={showAdjustmentModal}
        hide={handleAdjustmentModal}
        type="approve"
        ids={checkedAdjustments}
        status="approved"
        request_type="office"
      />
      <AdjustmentModal
        show={showDisapproveModal}
        hide={handleDisapproveModal}
        type="disapprove"
        ids={checkedAdjustments}
        status="disapproved"
        request_type="office"
      />
      <Footer />
    </div>
  )
}
